import React, { useState } from "react";
import "./Pagecomp.css";

function Pagecomp({ name, url, images, tags, description }) {

  const [more, setMore] = useState(true)
  const [moreText, setMoreText] = useState("See More")

  const toggleBool = () => {
    if (more) {
      setMore(false)
      setMoreText("See Less")
    }else{
      setMore(true)
      setMoreText("See More")
    }
  }

  console.log(more);
  return (
    <div>
      <div className="card">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <div className="card-header">
            <img src={images.default} alt="rover" />
          </div>
        </a>
        <div className="card-body">
          <div className="slills">
            {tags.map((tag) => (
              <span key={tag.name}>{tag.name}</span>
            ))}
          </div>
          <a href={url} target="_blank" rel="noopener noreferrer">
            <h4 className="head-text">{name}</h4>
          </a>
          <p style={{ padding: "0.6rem", margin: "0.3rem" }}>{more ? description.slice(0, 120) : description }<button style={{ backgroundColor: "white",
    border: "none",
    color: "blue",
    fontSize: "1rem", margin: ".3rem", cursor: "pointer"}} onClick={toggleBool}>{moreText}</button></p>
        </div>
      </div>
    </div>
  );
}

export default Pagecomp;
